module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-horizontal-side-mask.7b19477c.png";